import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { EthereumAlchemy, OptimismAlchemy, PolygonAlchemy } from '../services'

export const getAlchemyForChain = (chain: ArpeggiSupportedChain) => {
  if (chain === 'ethereum') return EthereumAlchemy
  if (chain === 'polygon') return PolygonAlchemy
  if (chain === 'optimism') return OptimismAlchemy
  return null
}
